import { render, staticRenderFns } from "./storeTransferLocation.vue?vue&type=template&id=52ffab04&"
import script from "./storeTransferLocation.vue?vue&type=script&lang=js&"
export * from "./storeTransferLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports